import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import EventsTheatreItemForm from "../EventsTheatrePage/EventsTheatreItemForm";
import EventsTheatreItemBrowser from "../EventsTheatrePage/EventsTheatreItemBrowser";

const EventsMusicalTheatrePage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="event"
            modeApiName2="events"
            ItemBrowserComponent={EventsTheatreItemBrowser}
            browserStyle={{width: "min(35%, 460px)", minWidth: "310px"}}
            browserFilterExtraParams={{kultural_goals: "musical_theatre"}}
            pageOptions={{kultural_goal: "musical_theatre"}}
            ItemFormComponent={EventsTheatreItemForm}
        />
    );
};

export default EventsMusicalTheatrePage;